/* src/app/vendor/vendor-presenter/vendor-presenter.component.scss */
body#themeTag :host ::ng-deep p-dropdown {
  width: 100%;
  max-width: 100%;
}
body#themeTag :host ::ng-deep .p-dropdown {
  line-height: 0.8em;
}
body#themeTag :host ::ng-deep .p-dropdown .p-dropdown-label {
  padding-right: 0;
  max-width: 105px;
}
body#themeTag :host ::ng-deep .p-dropdown .p-dropdown-trigger {
  background-color: transparent !important;
  color: black !important;
}
body#themeTag :host ::ng-deep .p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon {
  color: #7a7a7a !important;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-bottom: 0;
}
/*# sourceMappingURL=vendor-presenter.component.css.map */
